import React from "react";
import { Modal, ModalBody, ModalFooter, Row, Col, Label } from "reactstrap";
import { Button, Typography } from "@material-ui/core";
import { StyledContent, StyledHeader } from "../../../styles";

export default (props) => {
    return (
        <Modal isOpen={props.isOpen}>
            <StyledHeader>
                <Typography variant="h5">Delete Vehicle</Typography>
            </StyledHeader>
            <StyledContent>
                <ModalBody>
                    <Row>
                        <Col>
                            <Label>Vehicle Reg. Number</Label>
                            <p>
                                <b>{props.vehicle.machine_reg}</b>
                            </p>
                        </Col>
                        <Col>
                            <Label>Vehicle Description</Label>
                            <p>
                                <b>{props.vehicle.machine_desc}</b>
                            </p>
                        </Col>
                    </Row>
                </ModalBody>
            </StyledContent>
            <ModalFooter>
                <Button variant="contained" onClick={() => props.close()}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                        props.setActivity('delete','vehicle',props.vehicleUID)
                        props.removeVehicle(props.vehicleUID);
                        props.close();
                    }}
                >
                    Remove
                </Button>
            </ModalFooter>
        </Modal>
    );
};
